export default __webpack_public_path__ + "static/media/logo_espol_blanco.c88fc745.svg";